import React from 'react';
import clsx from 'clsx';
import { useProgressLoader } from '../../headless/ProgressLoader';
import styles from './ProgressLoader.scss';
export function ProgressLoaderContent(_ref) {
  let {
    children,
    className
  } = _ref;
  const {
    progress,
    count,
    totalCount
  } = useProgressLoader();
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.bottomContent, className)
  }, children(progress, count, totalCount));
}
//# sourceMappingURL=ProgressLoaderContent.js.map